import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import ArrayHelper from 'foundation/array-helper';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import { getPlayerSitecoreData } from 'general/js/helpers';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';
import { bemClasses, LivePreMessage } from 'components/live-pre-message';
import { playerSitecoreData } from 'components/live-player';
import LeaderboardAlphaList from './components/leaderboard-alpha-list';
import LeaderboardContainer from './leaderboard-container';

class LeaderboardLayout extends React.Component {
    componentDidMount() {
        if (this.props.options.isLastChanceQualifier) {
            ScoringLoader.subscribe(endpointNames.LEADERBOARD_LAST_CHANCE_QUALIFIER);
            ScoringLoader.subscribe(endpointNames.PLAYERS_LAST_CHANCE_QUALIFIER);
        } else {
            ScoringLoader.subscribe(endpointNames.LEADERBOARD);
            ScoringLoader.subscribe(endpointNames.PLAYERS);
        }

        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.subscribe(endpointNames.COURSE);
    }

    componentWillUnmount() {
        if (this.props.options.isLastChanceQualifier) {
            ScoringLoader.unsubscribe(endpointNames.LEADERBOARD_LAST_CHANCE_QUALIFIER);
            ScoringLoader.unsubscribe(endpointNames.PLAYERS_LAST_CHANCE_QUALIFIER);
        } else {
            ScoringLoader.unsubscribe(endpointNames.LEADERBOARD);
            ScoringLoader.unsubscribe(endpointNames.PLAYERS);
        }

        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.unsubscribe(endpointNames.COURSE);
    }

    isPlayOffMode() {
        return this.props.scoringLeaderboard.players.some((player) => {
            return (player.sitecoreData &&
                (player.sitecoreData.playOffStatus ||
                    player.sitecoreData.suddenDeathStatus ||
                    player.sitecoreData.isChampion));
        });
    }

    hasChampion() {
        return this.props.scoringLeaderboard.players.some((player) => {
            return player.sitecoreData && player.sitecoreData.isChampion;
        });
    }

    render() {
        const {
            liveScanner,
            scoringLeaderboard,
            scoringCourse,
            sitecorePlayers,
            options
        } = this.props;

        if (liveScanner === undefined ||
            sitecorePlayers === undefined ||
            scoringCourse === undefined ||
            scoringLeaderboard === undefined
        ) {
            return (
                <BlockPlaceholder minHeight={300}>
                    <BlockSpinner />
                </BlockPlaceholder>
            );
        }

        const isLcq = options.isLastChanceQualifier;

        const config = isLcq ?
            get(liveScanner, 'liveComponents.leaderboardLcq') :
            get(liveScanner, 'liveComponents.leaderboard');

        const activeRoundId = isLcq ?
            liveScanner.lcqScoringConfig.lcqLeaderboardActiveRoundId :
            liveScanner.activeRoundId;

        if (!config.show ||
            !activeRoundId ||
            !sitecorePlayers ||
            !scoringCourse ||
            !scoringLeaderboard ||
            ArrayHelper.isEmpty(scoringCourse.courseRounds)
        ) {
            const messageModel = {
                title: config.title,
                body: config.subtitle,
                textColor: config.textColor
            };
            return <LivePreMessage
                model={messageModel}
                bemList={[bemClasses.LIGHT, bemClasses.NTT]}
                patronLogo={options.patronLogo}
            />;
        }

        if (ArrayHelper.isEmpty(scoringLeaderboard.players)) {
            return <LeaderboardAlphaList players={sitecorePlayers.players} isLcq={isLcq} />;
        }

        const isPlayOffMode = this.isPlayOffMode();
        const hasChampion = this.hasChampion();

        return (
            <LeaderboardContainer
                options={options}
                liveScanner={liveScanner}
                scoringCourse={scoringCourse}
                scoringLeaderboard={scoringLeaderboard}
                isPlayOffMode={isPlayOffMode}
                hasChampion={hasChampion}
            />
        );
    }
}

LeaderboardLayout.propTypes = {
    options: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const isLcq = ownProps.options.isLastChanceQualifier;

    const sitecorePlayers = isLcq ?
        state.scoring[endpointNames.PLAYERS_LAST_CHANCE_QUALIFIER] :
        state.scoring[endpointNames.PLAYERS];

    const scoringLeaderboard = isLcq ?
        state.scoring[endpointNames.LEADERBOARD_LAST_CHANCE_QUALIFIER] :
        state.scoring[endpointNames.LEADERBOARD];

    if (sitecorePlayers === undefined) return {};

    if (sitecorePlayers &&
        scoringLeaderboard &&
        !ArrayHelper.isEmpty(scoringLeaderboard.players)
    ) {
        scoringLeaderboard.players.forEach((player) => {
            player.sitecoreData =
                getPlayerSitecoreData(sitecorePlayers, player.id) ||
                playerSitecoreData;
        });
    }

    return ({
        liveScanner: state.scoring[endpointNames.LIVE_SCANNER],
        scoringCourse: state.scoring[endpointNames.COURSE],
        scoringLeaderboard,
        sitecorePlayers,
    });
};

const LeaderboardLayoutWrapper = connect(
    mapStateToProps,
    null
)(LeaderboardLayout);

export default LeaderboardLayoutWrapper;
